export const events = {
  submitUniversalExport: 'Submit universal export',
}
